import { BRAND } from 'theme';

/** Цвета плоских иллюстраций главной: фирменные плюс несколько для акцентов. */
export const INK = BRAND.ink;
export const ACCENT = BRAND.accent;
export const SKY = BRAND.sky;
export const SKY_DARK = '#8FB3FF';
export const SUN = '#FFD666';
export const LEAF = '#2A9D8F';
export const CORAL = '#E76E50';
